import React from 'react';
import { buildQuoteProducts, quoteProductSummary } from '../utils/quoteProducts';
import './QuoteProductsTable.css';

export default function QuoteProductsSummary({ quote, showHeading = true, showClassification = true, principalLabel = 'Principal', categoryLabel = 'Product Category' }) {
  const products = Array.isArray(quote?.products)
    ? quote.products
    : quote?.product_code ? buildQuoteProducts(quote) : [];
  const summary = quoteProductSummary(products);
  const unitPriceTotal = quoteProductSummary(products.map(row => ({ total: row.unit_price }))).total;
  const money = value => value != null && value !== '' ? '₹ ' + Number(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';
  const classificationName = (row, relation) => {
    if (row[relation]?.name) return row[relation].name;
    const id = row[relation + '_id'];
    const quoteId = quote?.[relation + '_id'] ?? quote?.[relation]?.id;
    return (id == null || String(id) === String(quoteId)) ? quote?.[relation]?.name || '—' : '—';
  };
  return (
    <section className="quote-products quote-products--readonly" aria-label="Quote product details">
      {showHeading && <div className="quote-products__heading"><h5>Products</h5></div>}
      <div className="quote-products__scroll">
        <table className="quote-products__table" aria-label="Saved quote products">
          <colgroup>
            {(showClassification ? [22, 18, 20, 10, 15, 15] : [40, 16, 22, 22]).map((width, index) =>
              <col key={index} style={{ width: width + '%' }} />)}
          </colgroup>
          <thead><tr>
            <th scope="col">Product Code</th>
            {showClassification && <><th scope="col" className="quote-products__classification">{principalLabel}</th><th scope="col" className="quote-products__classification">{categoryLabel}</th></>}
            <th scope="col" className="quote-products__qty">QTY.</th>
            <th scope="col" className="quote-products__money">Unit Price</th>
            <th scope="col" className="quote-products__money">Total</th>
          </tr></thead>
          <tbody>{products.map((row, index) => <tr key={row.id ?? row._key ?? index}>
            <td>{row.product_code || '—'}</td>
            {showClassification && <>
              <td className="quote-products__classification">{classificationName(row, 'principal')}</td>
              <td className="quote-products__classification">{classificationName(row, 'category')}</td>
            </>}
            <td className="quote-products__qty">{row.qty ?? '—'}</td>
            <td className="quote-products__money">{money(row.unit_price)}</td>
            <td className="quote-products__money">{money(row.total)}</td>
          </tr>)}
            {!products.length && <tr><td colSpan={showClassification ? 6 : 4} className="quote-products__empty">No products found</td></tr>}
          </tbody>
          <tfoot>
            <tr>
              <th scope="row" colSpan={showClassification ? 3 : 1}>Grand Total</th>
              <td className="quote-products__qty">{products.length ? summary.qty : '—'}</td>
              <td className="quote-products__money">{money(unitPriceTotal)}</td>
              <td className="quote-products__money">{money(summary.total)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
  );
}
